import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { PageHero } from "../components/programmatic/PageHero"
import { Breadcrumbs } from "../components/programmatic/Breadcrumbs"
import { ServiceCTA } from "../components/programmatic/ServiceCTA"
import { AuthorBox } from "../components/programmatic/AuthorBox"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"
import { buildBreadcrumbList } from "../components/SEO/schema/breadcrumbList"
import glossary from "../data/glossary.json"
import type { GlossaryEntry } from "../data/types"

const entries = glossary as GlossaryEntry[]

const GlossarioPage = () => {
  const crumbs = [
    { name: "Início", to: "/" },
    { name: "Glossário", to: "/glossario" },
  ]

  const jsonLd = [buildLocalBusiness(), buildBreadcrumbList(crumbs)]

  return (
    <Layout>
      <SEO
        title="Glossário de Terapias Integrativas"
        description="Glossário com definições claras de Reiki, Tarô Alquímico, Florais Alkhemy Lab, Barras de Access Consciousness e termos relacionados. Por Gabriela Muttoni."
        canonicalPath="/glossario"
        jsonLd={jsonLd}
      />
      <Breadcrumbs crumbs={crumbs} />
      <PageHero
        eyebrow="Glossário"
        headline="Glossário de Terapias Integrativas"
        intro="Definições claras, sem misticismo desnecessário, sobre as principais práticas que atendo. Cada termo tem origem, mecanismo, indicações e limites."
      />
      <section className="text-gray-700 body-font">
        <div className="container mx-auto px-5 py-10">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
            {entries.map((entry) => (
              <li key={entry.slug}>
                <Link
                  to={`/glossario/${entry.slug}`}
                  className="block bg-purple-50 hover:bg-purple-100 rounded p-5 transition-colors"
                >
                  <h2 className="text-lg font-medium text-gray-900 mb-2">
                    {entry.term}
                  </h2>
                  <p className="text-sm text-gray-600 line-clamp-3">
                    {entry.shortDefinition}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <ServiceCTA prefill="Olá Gabriela, vim do glossário do site e gostaria de saber mais." />
      <AuthorBox />
    </Layout>
  )
}

export default GlossarioPage
